<template>
  <!-- 新建派车 -->
  <div class="contentBox">
    <div class="dispatch_head">
      <div class="topBtns">
        <el-button
          style="margin-top: 10px"
          class="glo_bgcMainColor"
          @click="submit('SAVE')"
          :disabled="!editable"
          v-if="editable"
          >保存</el-button
        >
        <el-button
          style="margin-top: 10px"
          class="glo_bg"
          @click="submit('DISPATCH')"
          v-if="!feeCheckIn && !intoStoreage && editable"
          :disabled="!editable || feeCheckIn"
          >调度确认</el-button
        >
        <el-button
          style="margin-top: 10px"
          class="glo_bg"
          @click="submit('POSTING')"
          v-if="feeCheckIn"
          >保存并过账</el-button
        >
        <el-button
          style="margin-top: 10px"
          class="glo_bg"
          @click="submit('POSTING')"
          v-if="intoStoreage"
          >卸货入库确认</el-button
        >
        <el-button style="margin-top: 10px" class="glo_bg" @click="back"
          >返回列表</el-button
        >
      </div>
      <div class="waybill_Type">{{ dispatchStatus }}</div>
    </div>
    <el-collapse v-model="activeNames">
      <!-- 发车信息 -->
      <el-collapse-item title="发车信息" name="1">
        <div class="infoDiv">
          <div class="formbox">
            <!-- :rules="rulesBaseInform" -->
            <el-form
              :model="departForm"
              ref="departFormRef"
              label-width="100px"
              class="glo_formBox"
            >
              <el-form-item label="发车批次" prop="dispatchNumber" required>
                <el-input
                  v-model="departForm.dispatchNumber"
                  placeholder="不填则保存后自动生成"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item label="派车类型" prop="dispatchType" required>
                <el-select
                  filterable
                  clearable
                  v-model="departForm.dispatchType"
                  placeholder="请选择"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="item in dispatchTypes"
                    :key="item.state"
                    :label="item.stateShow"
                    :value="item.state"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出车时间" prop="planDepartureTime" required>
                <el-date-picker
                  v-model="departForm.planDepartureTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择"
                  :disabled="!editable || feeCheckIn"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="始发网点:" prop="startDeptId" required>
                <el-select
                  v-model="departForm.startDeptId"
                  placeholder="请选择"
                  clearable
                  :disabled="!editable || feeCheckIn"
                  filterable
                >
                  <el-option
                    v-for="item in businessDepts"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="终端网点:">
                <el-select
                  filterable
                  clearable
                  v-model="departForm.endDeptId"
                  placeholder="请输入"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="item in allDepts"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="车辆类型"
                prop="carCategoryConfDictId"
                required
              >
                <el-select
                  filterable
                  clearable
                  v-model="departForm.carCategoryConfDictId"
                  placeholder="请选择"
                  @change="changecarCategoryConfDictId"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="item in car_categoryList"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item required label="车牌号" prop="carNumber">
                <el-select
                  filterable
                  clearable
                  allow-create
                  remote
                  v-model="departForm.carNumber"
                  placeholder="请选择或输入"
                  :disabled="!editable || feeCheckIn"
                  @change="changeCPH"
                >
                  <el-option
                    v-for="(item, index) in carNumberList"
                    :key="index"
                    :label="item.carNumber"
                    :value="item.carNumber"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="挂车车牌号" prop="trailerNumber">
                <el-select
                  filterable
                  clearable
                  allow-create
                  remote
                  v-model="departForm.trailerNumber"
                  placeholder="请选择或输入"
                  :disabled="!editable || feeCheckIn"
                  @change="changeGCH"
                >
                  <el-option
                    v-for="(item, index) in carNumberList"
                    :key="index"
                    :label="item.carNumber"
                    :value="item.carNumber"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="driverOneName" label="司机姓名" required>
                <el-select
                  filterable
                  clearable
                  allow-create
                  remote
                  v-model="departForm.driverOneName"
                  placeholder="请选择或输入"
                  :disabled="!editable || feeCheckIn"
                  @change="changeDriver"
                >
                  <el-option
                    v-for="(item, index) in drivers"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="driverOnePhone" label="司机电话">
                <el-input
                  v-model="departForm.driverOnePhone"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item prop="driverOneIdcard" label="身份证号">
                <el-input
                  v-model="departForm.driverOneIdcard"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item label="合同编号" prop="dispatchContractNumber">
                <el-input
                  v-model="departForm.dispatchContractNumber"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                />
              </el-form-item>
              <el-form-item label="外发员" prop="outgoingPersonnelId">
                <el-select
                  filterable
                  clearable
                  v-model="departForm.outgoingPersonnelId"
                  placeholder="请选择"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="emp in emps"
                    :key="emp.employeeId"
                    :label="emp.jobNumber"
                    :value="emp.employeeId"
                  >
                    <span style="float: left">{{ emp.jobNumber }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ emp.employeeName }}</span
                    >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="textArea"
                style="width: 100%; height: auto"
                label="备注"
                prop="remarks"
                :disabled="!editable || feeCheckIn"
              >
                <el-input
                  placeholder="请输入"
                  clearable
                  rows="3"
                  v-model="departForm.remarks"
                  type="textarea"
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalCount" label="总件数:">
                <el-input
                  v-model="departForm.totalCount"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalWeight" label="总重量">
                <el-input
                  v-model="departForm.totalWeight"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalVolume" label="总体积">
                <el-input
                  v-model="departForm.totalVolume"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalVote" label="总票数">
                <el-input
                  v-model="departForm.totalVote"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="应付合计" prop="totalAmount">
                <el-input
                  v-model="departForm.totalAmount"
                  placeholder="根据下方数据自动算出"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="textArea"
                style="width: 100%"
                label="起止线路"
                prop="startEndLineName"
                :disabled="!editable || feeCheckIn"
              >
                <el-input
                  placeholder="点击途经网点选择途径网点，设置顺序，显示自动把始发网点、和终端网点作为起止点"
                  clearable
                  rows="2"
                  v-model="departForm.startEndLineName"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="upload_pic" style="margin-bottom: 10px">
              <div
                style="
                  margin-bottom: 10px;
                  font-size: 13px;
                  color: #303133;
                  line-height: 1.769230769230769;
                "
              >
                上传图片: (支持上传jpg/png文件)
              </div>
              <my-image-upload
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="9"
                :disabled="!editable || feeCheckIn"
              ></my-image-upload>
            </div>
            <el-form label-position="left" label-width="80px">
              <el-form-item label="更多信息">
                <el-link
                  @click="showMoreInfo = !showMoreInfo"
                  type="primary"
                  :underline="false"
                  >{{ showMoreInfo ? "收起" : "展开" }}</el-link
                >
              </el-form-item>
              <add-other-info
                v-show="showMoreInfo"
                border
                v-model="departForm"
                :type="type"
              ></add-other-info>
            </el-form>
          </div>
        </div>
      </el-collapse-item>
      <!-- 运单/订单装载明细 -->
      <el-collapse-item
        name="2"
        class="details_item"
        v-if="!intoStoreage && type !== 'gan_xian_pei_zai'"
      >
        <template slot="title">
          <div
            :class="isWaybill ? 'active_item' : ''"
            style="padding-right: 10px"
            @click.stop="isWaybill = !isWaybill"
          >
            运单装载明细
          </div>
          <div
            class="soltTitle"
            :class="!isWaybill ? 'active_item' : ''"
            @click.stop="isWaybill = !isWaybill"
            v-if="type === 'shang_men_ti_huo'"
          >
            订单装载明细
          </div>
        </template>
        <waybills
          v-show="isWaybill"
          :dispatchId="dispatchId"
          ref="waybill"
          :op="op"
          :isSee="isSee"
          @calcAll="calcAll"
        ></waybills>
        <commands
          v-show="!isWaybill"
          :dispatchId="dispatchId"
          ref="command"
          :op="op"
          :isSee="isSee"
          v-if="type === 'shang_men_ti_huo'"
          @calcAll="calcAll"
        ></commands>
      </el-collapse-item>
      <!-- 车次费用 -->
      <el-collapse-item
        name="3"
        title="车次费用"
        class="details_item"
        v-if="!intoStoreage"
      >
        <car-timing
          ref="carTiming"
          :dispatchId="dispatchId"
          :isSee="isSee"
          :op="op"
          :carTiming="carTiming"
        ></car-timing>
      </el-collapse-item>
      <!-- 车次费用 -->
      <el-collapse-item
        name="4"
        title="卸货明细"
        class="details_item"
        v-if="intoStoreage"
      >
        <storeage
          ref="carTiming"
          :dispatchId="dispatchId"
          :isSee="isSee"
          :op="op"
          :carTiming="carTiming"
        ></storeage>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import paging from "@/components/pagings.vue"; //分页组件
import waybills from "./waybills.vue";
import commands from "./commands.vue";
import carTiming from "./carTiming.vue";
import MyImageUpload from "@/components/MyImageUpload.vue";
import Storeage from "./Storeage.vue";
import AddOtherInfo from "./AddOtherInfo.vue";
export default {
  components: {
    paging,
    waybills,
    commands,
    carTiming,
    MyImageUpload,
    Storeage,
    AddOtherInfo,
  },
  props: {
    dispatchId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "edit",
    },
    op: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  data() {
    return {
      dispatchStatus: "未派车", // 派车状态
      activeNames: ["1", "2", "3"],
      departForm: {
        dispatchNumber: null,
        dispatchType: null,
        planDepartureTime: null,
        startDeptId: null,
        endDeptId: null,
        carCategoryConfDictId: null,
        carNumber: null,
        driverOneId: null,
        driverOneName: null,
        driverOnePhone: null,
        driverOneIdcard: null,
        dispatchContractNumber: null,
        outgoingPersonnelId: null,
        outgoingPersonnelName: null,
        remarks: null,
        totalCount: null,
        totalWeight: null,
        totalVolume: null,
        totalVote: null,
        totalAmount: null,
        route: null,
        startEndLineName : null,
        carrying001: [],
        carrying002: [],
        carTrailerVehicleTare: null,
        loadRate: null,
      },
      dispatchTypes: [],
      businessDepts: [], // 网点
      allDepts: [], // 网点
      car_categoryList: [], //车辆分类
      carNumberList: [], // 车牌号
      drivers: [],
      fileNameLists: [], // 图片列表
      emps: [],
      /**------运单/订单明细表格 */
      isWaybill: true, // 运单/订单明细
      loadingDetails: [], // 运单/订单明细表格data
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "auto", //  表格高度
      selectTableData: [], //  表格选中的数据
      /**--------- */
      /**-------车次费用表格 */
      trainCostData: [],
      /**--------------- */
      previewSrcList: [],
      showViewer: false,
      carTiming: [],
      showMoreInfo: false,
      carrying001: [],
      carrying002: [],
    };
  },
  computed: {
    editable() {
      console.log(this.isSee);
      return this.isSee != 1;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.op === "feeCheckIn";
    },
    baseEdit() {
      return this.op === "baseEdit";
    },
    intoStoreage() {
      return this.op === "intoStoreage";
    },
  },
  mounted() {
    this.getDispatchTypes();
    this.getBusinessDepts();
    this.getAllDepts();
    this.getConfDictValDownList("car_category", "car_categoryList");
    // 员工
    this.getEmps();
    this.getDetail();
    this.getDrivers();
  },
  methods: {
    async getDetail() {
      if (this.dispatchId) {
        const detail = await this.$API.getDispatchUpdateDetail({
          dispatchId: this.dispatchId,
        });
        const result = detail.data.result;
        if (result.carCategoryConfDictId) {
          result.carCategoryConfDictId = parseInt(result.carCategoryConfDictId);
        }
        this.departForm = result;
        this.departForm.totalVote = this.departForm.totalBillCount;
        this.fileNameLists = result.files;
        this.carTiming = result.fianceOutInfos;
        this.dispatchStatus = result.dispatchStatusShow;
        this.carrying001 = result.carrying001;
        this.carrying002 = result.carrying002;
      }
    },
    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    // 获取全部网点
    async getAllDepts() {
      const data = await this.$API.runListReport({
        number: "all_dept_storage_down_list",
      });
      this.allDepts = data;
    },
    // 获取派车类型
    async getDispatchTypes() {
      const data = await this.$API.runListReport({
        number: "down_list_dispatch_type_v5",
      });
      this.dispatchTypes = data;
    },
    calcAll() {
      let waybills = this.$refs.waybill ? this.$refs.waybill.getRows() : [];
      let commands = this.$refs.command ? this.$refs.command.getRows() : [];
      let totalCount = 0;
      let totalGrossWeight = 0;
      let totalVolume = 0;
      let totalVote = 0;
      waybills = waybills.filter((item) => item.operationType != "DEL");
      waybills.map((item) => {
        totalCount = this.$TOOLS.add(totalCount, item.packageCount || 0);
        totalGrossWeight = this.$TOOLS.add(
          totalGrossWeight,
          item.totalGrossWeight || 0
        );
        totalVolume = this.$TOOLS.add(totalVolume, item.totalVolume || 0);
        console.log(item);
      });
      commands = commands.filter((item) => item.operationType != "DEL");
      commands.map((item) => {
        totalCount = this.$TOOLS.add(totalCount, item.packageCount || 0);
      });
      this.departForm.totalCount = totalCount;
      this.departForm.totalWeight = totalGrossWeight;
      this.departForm.totalVolume = totalVolume;
      this.departForm.totalVote = this.$TOOLS.add(
        waybills.length,
        commands.length
      );
    },
    // 保存
    async submit(saveType) {
      const waybills = this.$refs.waybill ? this.$refs.waybill.getRows() : [];
      const commands = this.$refs.command ? this.$refs.command.getRows() : [];
      const carTimeings = this.$refs.carTiming.getRows();
      if (this.departForm.outgoingPersonnelId === "") {
        this.departForm.outgoingPersonnelId = null;
      }
      if (this.dispatchId) {
        if (this.feeCheckIn) {
          const res = await this.$API.saveDispatchFinance({
            dispatchId: this.dispatchId,
            fianceOutInfos: carTimeings,
            saveType,
          });
          this.$message.success("保存成功");
          this.back();
        } else {
          // if (saveType == "SAVE") {
          //   const res = await this.$API.updateDispatch({
          //     ...this.departForm,
          //     dispatchId: this.dispatchId,
          //     billInfos: waybills,
          //     commandBillInfos: commands,
          //     fianceOutInfos: carTimeings,
          //     files: this.fileNameLists,
          //     saveType,
          //   });
          //   this.$message.success("保存成功");
          //   this.back();
          // }
          // else {
          //   const res = await this.$API.dispatchSureV5({
          //     dispatchIds: [this.dispatchId],
          //   });
          //   this.$message.success("调度成功");
          //   this.back();
          // }
          const res = await this.$API.updateDispatch({
            ...this.departForm,
            dispatchId: this.dispatchId,
            billInfos: waybills,
            commandBillInfos: commands,
            fianceOutInfos: carTimeings,
            files: this.fileNameLists,
            saveType,
          });
          this.$message.success("保存成功");
          this.back();
        }
      } else {
        const res = await this.$API.addDispatch({
          ...this.departForm,
          billInfos: waybills,
          commandBillInfos: commands,
          fianceOutInfos: carTimeings,
          files: this.fileNameLists,
          saveType,
        });
        this.$message.success(saveType == "SAVE" ? "保存成功" : "调度成功");
        this.back();
      }
      this.$emit("reset");
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    // 获取车辆下拉列表(拿车牌号码)
    async changecarCategoryConfDictId(e) {
      if (e) {
        const res = await this.$API.runList({
          number: "down_list_car",
          carCategoryConfDictId: e, //车辆分类id
        });
        this.carNumberList = res;
      }
    },
    async getDrivers() {
      const res = await this.$API.runList({
        number: "down_list_driver",
      });
      this.drivers = res;
    },

    // 车牌号码
    changeCPH(e){
      const matchers = this.carNumberList.filter(
        (item) => item.carNumber === e
      );
      console.log(matchers);
      if(matchers.length>0){
        this.departForm.totalQuality = matchers[0].totalQuality || ''
        this.departForm.vehicleTare = matchers[0].vehicleTare || ''
      }
    },
    // 挂车号码
    changeGCH(e){
      const matchers = this.carNumberList.filter(
        (item) => item.carNumber === e
      );
      console.log(matchers);
      if(matchers.length>0){
        this.departForm.totalQuality = matchers[0].totalQuality || ''
        this.departForm.carTrailerVehicleTare = matchers[0].vehicleTare || ''
      }
    },
    changeDriver() {
      const matchers = this.drivers.filter(
        (item) => item.name === this.departForm.driverOneName
      );
      if (matchers.length === 0) {
        this.departForm.driverOneIdcard = null;
        this.departForm.driverOnePhone = null;
        return;
      }
      const driver = matchers[0];
      this.departForm.driverOneId = driver.id;
      this.departForm.driverOneIdcard = driver.idCard;
      this.departForm.driverOnePhone = driver.phone;
    },
    back() {
      let scope = "shangmentihuo";
      switch (this.type) {
        case "gan_xian_pei_zai":
          scope = "ganxian";
          break;
        case "song_huo_shang_men":
          scope = "songhuoshangmen";
          break;
        case "song_chu_wai_fa":
          scope = "songchuwaifa";
          break;
      }
      this.$BaseIndex.closeCurrentTab("/DispatchCar/" + scope);
    },
  },
};
</script>

<style scoped lang="less">
.contentBox {
  padding-bottom: 50px;
  .dispatch_head {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    .topBtns {
      background-color: #fff;
      margin-top: -10px;
      // height: 50px;
    }
    .waybill_Type {
      // margin-bottom: 10px;
      width: fit-content;
      height: max-content;
      color: #ff0000;
      font-weight: bold;
      border: 2px dashed transparent;
      border-radius: 5px;
      padding: 2px 12px;
      background: linear-gradient(#fff, #fff) padding-box,
        repeating-linear-gradient(
          -75deg,
          #ff0000 0,
          #ff0000 0.9em,
          #fff 0,
          #fff 1.2em
        );
    }
  }

  .infoDiv {
    // border-width: 1px 1px 0 1px;
    // border-style: solid;
    // border-color: #f59a23;
    display: flex;
    .formbox {
      // padding: 0 30px;
      padding: 0 10px;
      // width: calc(100% - 70px);
      width: 100%;
      .glo_formBox {
        // justify-content: space-between;
        .el-form-item {
          margin-right: 1.8%;
        }
        .double_item {
          /deep/.el-form-item__content {
            display: flex;
            .el-select {
              input {
                padding-left: 5px;
              }
            }
            .second_ipt {
              input {
                padding-left: 5px;
                padding-right: 10px;
              }
            }
            .unit {
              margin-right: 5px;
            }
          }
        }
        .Divider {
          width: 100%;
          height: 1px;
          margin-bottom: 10px;
          border-top: 1px dashed transparent;
          background: linear-gradient(#fff, #fff) padding-box,
            repeating-linear-gradient(
              -75deg,
              #797979 0,
              #797979 0.9em,
              #fff 0,
              #fff 1.2em
            );
        }
      }
      .head_formBox {
        justify-content: flex-start;
        margin: 15px 0 5px 0;
        .el-form-item {
          margin-bottom: 10px;
          // width: 18%;
          width: calc(24% - 2px);
          min-width: unset;
        }
      }
      .jsInput {
        .jsBtns {
          height: 30px;
          line-height: 30px;
          margin: 0;
          padding: 0 10px;
          border: none;
        }
      }
    }

    .goodsItmes {
      margin: 10px 0;
      // margin-top: 30px;
      // border-bottom: 4px solid #ccc;
      // padding-bottom: 20px;
    }

    .formBtns {
      height: 30px;
      margin: 0;
      padding: 0 10px;
    }

    .miniInput {
      width: 80px;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      margin-right: 2px;

      text-align: center;

      /deep/ .el-input__inner {
        text-align: center !important;
        padding: 0 5px;
      }
    }
  }
  .el-collapse {
    .details_item {
      .el-collapse-item__header {
        .active_item {
          background: #ffffff;
          color: #ef7c0a;
        }
        .soltTitle {
          padding: 0 10px;
        }
      }
    }
  }
  .cost_dia {
    /deep/.el-dialog {
      .glo_dialogForm {
        .diaForm {
          .el-row {
            width: 100%;
            .multipleSelect {
              display: flex;
              /deep/ .el-select {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
}
</style>